module.exports = __webpack_public_path__ + "img/no-watches.1ebeb220.svg";